/**
 * @generated SignedSource<<a4442d9224903f2c49bb30d4ca972348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee$data = ReadonlyArray<{
  readonly id: string;
  readonly shifts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift">;
  }>;
  readonly " $fragmentType": "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee";
}>;
export type WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee$key = ReadonlyArray<{
  readonly " $data"?: WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationIpoolShift",
      "kind": "LinkedField",
      "name": "shifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IntegrationIpoolEmployee",
  "abstractKey": null
};
})();

(node as any).hash = "52194b50e13514438a71dd9501e83c1d";

export default node;
